<template>
    <a id="asl-getting-started-help" href="#" @click.prevent="showGettingStartedPage"
        aria-label="Sign language remote help">
        <svg class="icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <g>
                <path id="Shape" fill-rule="evenodd" clip-rule="evenodd"
                    d="M13.8934 4.66699H18.1067C21.0842 4.66699 23.9398 5.8498 26.0452 7.95521C28.1506 10.0606 29.3334 12.9162 29.3334 15.8937V16.107C29.3334 19.0845 28.1506 21.94 26.0452 24.0454C23.9398 26.1509 21.0842 27.3337 18.1067 27.3337H13.8934C10.9159 27.3337 8.06037 26.1509 5.95496 24.0454C3.84955 21.94 2.66675 19.0845 2.66675 16.107V15.8937C2.66675 9.69334 7.6931 4.66699 13.8934 4.66699ZM27.3334 15.8937C27.3334 10.7979 23.2025 6.66699 18.1067 6.66699H13.8934C8.79767 6.66699 4.66675 10.7979 4.66675 15.8937V16.107C4.66675 18.5541 5.63884 20.9009 7.36918 22.6312C9.09951 24.3616 11.4464 25.3337 13.8934 25.3337H18.1067C23.2025 25.3337 27.3334 21.2027 27.3334 16.107V15.8937ZM18.8534 12.2803C18.6748 11.9493 18.435 11.6553 18.1467 11.4137C17.8511 11.1737 17.5177 10.9844 17.1601 10.8537C16.7864 10.7279 16.3944 10.6648 16.0001 10.667C15.2749 10.6387 14.5612 10.8547 13.9734 11.2803C13.4351 11.6937 13.0352 12.261 12.8267 12.907L14.5601 13.427C14.674 13.1457 14.8631 12.9012 15.1067 12.7203C15.3646 12.5316 15.6816 12.4417 16.0001 12.467C16.2965 12.4566 16.5862 12.5564 16.8134 12.747C17.024 12.9213 17.1462 13.1803 17.1467 13.4537C17.1422 13.7376 17.0218 14.0074 16.8134 14.2003C16.5708 14.4478 16.3125 14.6794 16.0401 14.8937L15.5734 15.307C15.418 15.4509 15.2794 15.6119 15.1601 15.787C15.0326 15.949 14.9293 16.1287 14.8534 16.3203C14.7728 16.5147 14.732 16.7232 14.7334 16.9337V18.107H16.6001V17.0003C16.6067 16.8332 16.6785 16.6752 16.8001 16.5603C16.9562 16.4046 17.1209 16.2577 17.2934 16.1203L17.8934 15.6803C18.1071 15.5133 18.2997 15.3207 18.4667 15.107C18.6528 14.8909 18.8056 14.6482 18.9201 14.387C19.0449 14.0828 19.1039 13.7556 19.0934 13.427C19.1036 13.0313 19.0214 12.6387 18.8534 12.2803ZM14.8001 19.9203C15.038 19.6861 15.3596 19.5566 15.6934 19.5603C16.0238 19.554 16.3422 19.6843 16.5734 19.9203C16.8133 20.1447 16.9495 20.4585 16.9495 20.787C16.9495 21.1155 16.8133 21.4293 16.5734 21.6537C16.3422 21.8897 16.0238 22.0199 15.6934 22.0137C15.3596 22.0174 15.038 21.8879 14.8001 21.6537C14.322 21.1748 14.322 20.3992 14.8001 19.9203Z"
                    fill="#F6F6F9" />
            </g>
        </svg>
    </a>
</template>

<script>
export default {
    name: 'ASLGettingStartedHelpLink',
    methods: {
        showGettingStartedPage: function () {
            arRouter.push('/asl-getting-started');
            return;
        }
    }
};
</script>

<style lang="scss" scoped>
.icon {
    width: 2rem;
    height: 2rem;
}

@include md {
    .icon {
        width: 3rem;
        height: 3rem;
    }
}
</style>
